module.exports = __webpack_public_path__ + "img/unactive-user.257b19ee.png";